import axios from 'axios';

const API_URL = 'https://manage.shokhdesign.uz'; // Replace with your backend API URL

const apiClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Function to get the latest articles
export const getLatestArticles = async () => {
  try {
    const response = await axios.get(`${API_URL}/latest-articles/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching latest articles:', error);
    return [];
  }
};

// Function to get all articles
export const getAllArticles = async () => {
  try {
    const response = await axios.get(`${API_URL}/all-articles/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching all articles:', error);
    return [];
  }
};

// API call to fetch all projects
export const getSelectedProjects = () => {
  return apiClient.get(`/selected-projects/`);
};

// API call to fetch all projects
export const getAllProjects = () => {
  return apiClient.get('/all-projects/');
};

// API call to fetch a specific project's details
export const getProjectDetail = (id) => {
  return apiClient.get(`/projects/${id}/`);
};

export default apiClient;